import React from 'react'
import '../sass/atoms.sass'

export const Progressbar = (props) => {

    const progress = (props.step ?? 0) / (props.totalSteps ?? 100) * 100 + '%'

    return <div className='progressbar'>
        <div className='inner' style={{width: progress}}></div>
    </div>


}